import * as React from 'react';
import { FormProvider as RcFormProvider } from '@rc-component/form';
import { omit } from '@rc-component/util';
export const FormContext = React.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: (() => { }),
});
export const NoStyleItemContext = React.createContext(null);
export const FormProvider = (props) => {
    const providerProps = omit(props, ['prefixCls']);
    return React.createElement(RcFormProvider, { ...providerProps });
};
export const FormItemPrefixContext = React.createContext({
    prefixCls: '',
});
export const FormItemInputContext = React.createContext({});
if (process.env.NODE_ENV !== 'production') {
    FormItemInputContext.displayName = 'FormItemInputContext';
}
export const NoFormStyle = ({ children, status, override }) => {
    const formItemInputContext = React.useContext(FormItemInputContext);
    const newFormItemInputContext = React.useMemo(() => {
        const newContext = { ...formItemInputContext };
        if (override) {
            delete newContext.isFormItemInput;
        }
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [status, override, formItemInputContext]);
    return (React.createElement(FormItemInputContext.Provider, { value: newFormItemInputContext }, children));
};
export const VariantContext = React.createContext(undefined);
